import { MwSmallIcon } from "./icons";
import Link from "next/link";
import CallToActionCustomer from "./cta-customer";
import { useTranslation } from "next-i18next";
import CallToActionDocsLink from "./blog/call-to-action-docs-link";

const CustomerStories = () => {
    const { t } = useTranslation('common');
    const storiesData = t('customers.stories', { returnObjects: true, defaultValue: {} }) as any;
    const customers = Array.isArray(storiesData?.customers) ? storiesData.customers : [];
    return (
        <>
            <div className={"more-story"}>
                <div className={"container"}>
                    <div className={'section-tag testimonial pd-right'}><MwSmallIcon /> {String(storiesData?.sectionTag ?? '')}</div>
                    <h2>{String(storiesData?.titlePrefix ?? '')}<span className={"text-gradient"}>{String(storiesData?.titleHighlight ?? '')}</span></h2>
                    <p>{String(storiesData?.description ?? '')}</p>

                    <div className={"d-flex"}>
                        {
                            customers.map((customer: any, index: number) => {
                                return <div key={index} className={`customers ${String(customer?.className ?? '')}`}>
                                    <div className={`logo ${String(customer?.className ?? '')}`}><img src={String(customer?.logo ?? '')} alt={String(customer?.title ?? '')} /></div>
                                    <h3>{String(customer?.title ?? '')}</h3>
                                    <Link href={String(customer?.link ?? '')} className={"read-more"}>{t('blog.cta.readMore')}</Link>
                                </div>
                            })
                        }
                    </div>

                </div>
            </div>
        </>
    )
}

export default CustomerStories;